import getCyberSourceInit from './get-cybersource-init';
import getOptileInit from './get-optile-init';
import getSavedCards from './get-saved-cards';
import getTrueLayerPaymentStatus from './get-true-layer-payment-status';
import getPoliPaymentStatus from './get-poli-payment-status';
import getTabapayCardDetails from './get-tabapay-card-details';
import getTabapayStatus from './get-tabapay-status';
import getCybersourceCardDetails from './get-cybersource-card-details';
import getAdyenInit from './get-adyen-init';
import getAdyenStatus from './get-adyen-status';
import getZepzPayinCards from './get-zepz-payin-cards';
import getZepzPayinInitData from './get-zepz-payin-init-data';
import getZepzPayinVerificationStatus from './get-zepz-payin-verification-status';

export default {
    getCyberSourceInit,
    getSavedCards,
    getTrueLayerPaymentStatus,
    getPoliPaymentStatus,
    getTabapayCardDetails,
    getTabapayStatus,
    getZepzPayinCards,
    getZepzPayinInitData,
    getZepzPayinVerificationStatus,
    getCybersourceCardDetails,
    getAdyenInit,
    getAdyenStatus,
    getOptileInit
};
